import {
	Component,
	Inject,
	Optional,
	ChangeDetectionStrategy,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

@Component({
	selector: 'app-read-report-modal',
	templateUrl: './read-report-modal.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./read-report-modal.component.scss'],
	imports: [MatIcon],
})
export class ReadReportModalComponent {
	public message: string = '';

	createReportQueueForm = new FormGroup({
		generation_date: new FormControl(null, [Validators.required]),
		generation_time: new FormControl(null, [Validators.required]),
	});

	constructor(
		public dialogRef: MatDialogRef<ReadReportModalComponent>,
		@Optional() @Inject(MAT_DIALOG_DATA) public data: any
	) {}

	ngOnInit() {
		this.initialData();
	}

	initialData() {
		this.message = this.data.message;
	}

	closeModal() {
		this.dialogRef.close(false);
	}
}
